import { Socket } from "socket.io-client";
import { useEffect, useRef } from "react";
import { toast } from "sonner";

import { createSocket } from "@/socket-client";
import { useAuth } from "@/lib/use-auth";
import { MdClose } from "react-icons/md";

export const SocketProvider = () => {
  const { data, isPending } = useAuth();

  const socketRef = useRef<Socket | null>(null);

  // const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!isPending && data?.user?._id) {
      socketRef.current = createSocket(data?.user?._id as string);

      socketRef.current.on("connect", () => {
        console.log("Connected to the server");
      });

      socketRef.current.on("announcement", (data) => {
        // console.log("Announcement received:", data);
        // toast("Bhai sahab");

        toast.custom(
          (t) => (
            <div className="p-4 w-[356px] rounded-md bg-primary text-primary-foreground shadow-md">
              <button
                onClick={() => toast.dismiss(t)}
                className="absolute right-2 top-2"
              >
                <MdClose className="w-4 h-4" />
              </button>
              <h1 className="font-semibold">{data?.title as string}</h1>
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.description,
                }}
              />
            </div>
          ),
          {
            duration: 50000,
          }
        );
      });

      socketRef.current.on("notification", (data) => {
        // console.log("Notification received:", data);
        // toast("Bhai sahab");
        // console.count();

        toast.custom(
          (t) => (
            <div className="p-4 w-[356px] rounded-md bg-primary text-primary-foreground shadow-md">
              <button
                onClick={() => toast.dismiss(t)}
                className="absolute right-2 top-2"
              >
                <MdClose className="w-4 h-4" />
              </button>
              <h1
                className="font-semibold"
                dangerouslySetInnerHTML={{
                  __html: data?.article,
                }}
              ></h1>
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.title,
                }}
              ></div>
            </div>
          ),
          {
            duration: 50000,
          }
        );
      });

      socketRef.current.on("todo", (data) => {
        // console.log("Notification received:", data);
        // toast("Bhai sahab");
        // console.count();

        toast.custom(
          (t) => (
            <div className="p-4 w-[356px] rounded-md bg-primary text-primary-foreground shadow-md">
              <button
                onClick={() => toast.dismiss(t)}
                className="absolute right-2 top-2"
              >
                <MdClose className="w-4 h-4" />
              </button>
              <h1 className="font-semibold">TODO</h1>

              <div className="flex flex-col">
                <div
                  className="text-lg font-semibold"
                  dangerouslySetInnerHTML={{
                    __html: data?.title,
                  }}
                ></div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data?.description,
                  }}
                ></div>
              </div>
            </div>
          ),
          {
            duration: 50000,
          }
        );
      });

      socketRef.current.on("disconnect", () => {
        console.log("Disconnected from the server");
      });

      return () => {
        // Clean up socket event listeners when component unmounts
        if (socketRef.current) {
          socketRef.current.off("connect");
          socketRef.current.off("announcement");
          socketRef.current.off("notification");
          socketRef.current.off("todo");
          socketRef.current.off("disconnect");
        }
      };
    }
  }, [data, isPending]);

  return <></>;
};
